"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var helper = require('../js/helper.js')["default"];

var errorHandler = require('../js/errors.js').handleError;

var provider = {
  state: {
    provider: {},
    editedProvider: {
      empty: true
    }
  },
  getters: {
    provider: function provider(state) {
      return state.provider;
    },
    getStat: function getStat(state) {
      return function (code) {
        if (state.provider.provider_stats) {
          return state.provider.provider_stats.filter(function (stat) {
            return stat.stat.code == code;
          }).map(function (stat) {
            return stat.value;
          })[0];
        }
      };
    },
    getDesc: function getDesc(state) {
      return function (code) {
        if (state.provider.provider_descriptions) {
          return state.provider.provider_descriptions.filter(function (desc) {
            return desc.description.code == code;
          }).map(function (desc) {
            return desc.value;
          })[0];
        }
      };
    },
    newProviderPosted: function newProviderPosted(state) {
      return state.provider.hasOwnProperty('id');
    },
    getEditedProvider: function getEditedProvider(state) {
      return state.editedProvider;
    },
    verifySync: function verifySync(state) {
      if (state.editedProvider.hasOwnProperty('empty') && state.editedProvider.empty) return false;
      var changes = helper.getDifferences(state.provider, state.editedProvider);
      if (changes.length != 0) return false;
      return true;
    },
    getProviderValueByKeyChain: function getProviderValueByKeyChain(state) {
      return function (keyChain) {
        var object = JSON.parse(JSON.stringify(state.provider));
        return helper.getWithKeyChain(object, keyChain);
      };
    },
    getEditedProviderValueByKeyChain: function getEditedProviderValueByKeyChain(state) {
      return function (keyChain) {
        var object = JSON.parse(JSON.stringify(state.editedProvider));
        return helper.getWithKeyChain(object, keyChain);
      };
    },
    getNonProviderValues: function getNonProviderValues(state, getters, rootState) {
      return function (keyChain) {
        var providerValues = state.provider[keyChain[0]].map(function (item) {
          return item[keyChain[2]];
        }).filter(function (item) {
          return item !== null;
        });
        var allValues = getters.providerPropertyToProperty(keyChain[0]);
        var nonProviderValues = allValues.filter(function (item) {
          return !providerValues.reduce(function (acc, cur) {
            return item.id == cur.id ? true : acc;
          }, false);
        });
        return nonProviderValues;
      };
    },
    isSelectedProperty: function isSelectedProperty(state, getters, rootState) {
      return function (property, propertyName, item) {
        return state.editedProvider[property].findIndex(function (providerItem) {
          return providerItem[propertyName + '_id'] == item.id;
        }) > -1;
      };
    },
    getNewProviderProperty: function getNewProviderProperty(state) {
      return function (property) {
        var newProviderProperty = helper._createEmpty(property, state.editedProvider.id);

        return newProviderProperty;
      };
    }
  },
  mutations: {
    setProvider: function setProvider(state, data) {
      state.provider = data;
    },
    setEditedProvider: function setEditedProvider(state, data) {
      state.editedProvider = data;
    },
    setEditedProviderByKeyChain: function setEditedProviderByKeyChain(state, payl) {
      var object = JSON.parse(JSON.stringify(state.editedProvider));
      var newObject = helper.setByKeyChain(object, payl);
      state.editedProvider = newObject;
    },
    deleteEditedProviderPropertyByKeyChain: function deleteEditedProviderPropertyByKeyChain(state, keyChain) {
      var object = JSON.parse(JSON.stringify(state.editedProvider));
      var newObject = helper.deleteByKeyChain(object, keyChain);
      state.editedProvider = newObject;
    },
    makeProviderDeepCopy: function makeProviderDeepCopy(state) {
      state.editedProvider = JSON.parse(JSON.stringify(state.provider));
    },
    createNewProvider: function createNewProvider(state) {
      state.provider = {};
      state.editedProvider = helper._createEmptyProvider();
    },
    createNewProviderProperty: function createNewProviderProperty(state, property) {
      var editedProvider = JSON.parse(JSON.stringify(state.editedProvider));

      var newProviderProperty = helper._createEmpty(property, state.editedProvider.id);

      editedProvider[property].push(newProviderProperty);
      state.editedProvider = editedProvider;
    }
  },
  actions: {
    fetchProviderById: function fetchProviderById(context) {
      var ops = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        provider_id: undefined,
        embed: undefined
      };
      return context.getters.api.provider.get(context.getters.token, ops.provider_id, ops.embed).then(function (r) {
        context.commit('setProvider', r.data);
        return r;
      })["catch"](function (err) {
        return errorHandler(err, context);
      });
    },
    fetchProviderForEdit: function fetchProviderForEdit(context, provider_id) {
      return context.dispatch('fetchProviderById', {
        provider_id: provider_id
      }).then(function (r) {
        context.commit('makeProviderDeepCopy');
      })["catch"](function (err) {
        return errorHandler(err, context);
      });
    },
    postNewProvider: function () {
      var _postNewProvider = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(context) {
        var data, provider_id;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = context.getters.getEditedProvider;
                _context.next = 3;
                return context.getters.api.provider.create(context.getters.token, data).then(function (r) {
                  if (r.status == 201) {
                    provider_id = r.data.id;
                    context.commit('setEditedProviderByKeyChain', {
                      keyChain: ['id'],
                      data: provider_id
                    });
                    context.dispatch('addMessage', {
                      text: 'New provider created',
                      type: 'info',
                      duration: 5000
                    });
                    return context.dispatch('fetchProviderById', {
                      provider_id: provider_id
                    });
                  }
                })["catch"](function (err) {
                  return errorHandler(err, context);
                });

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function postNewProvider(_x) {
        return _postNewProvider.apply(this, arguments);
      }

      return postNewProvider;
    }(),
    postEdits: function postEdits(context) {
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var editedProvider, changes, token, outcomes;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  editedProvider = context.getters.getEditedProvider;

                  if (editedProvider.id) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 4;
                  return context.dispatch('postNewProvider');

                case 4:
                  if (editedProvider.id) {
                    _context2.next = 6;
                    break;
                  }

                  return _context2.abrupt("return");

                case 6:
                  changes = helper.getDifferences(context.getters.provider, context.getters.getEditedProvider);
                  token = context.getters.token;
                  if (filter) changes = _filter_changes(changes, filter);
                  _context2.next = 11;
                  return _post_changes(token, context, changes);

                case 11:
                  outcomes = _context2.sent;

                  if (!outcomes.errorEvent && changes.length > 0) {
                    context.dispatch('addMessage', {
                      text: 'All changes have been saved.',
                      type: 'info',
                      duration: 5000
                    });
                    context.dispatch('fetchProviderForEdit', context.getters.getEditedProvider.id);
                    resolve();
                  } else {
                    reject();
                  }

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};

function _filter_changes(changes, filter) {
  var new_changes = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = changes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var change = _step.value;

      if (change.method.toLowerCase().includes(filter) || change.method.includes(filter) || change.method.includes(helper._mapPropToMethod(filter, 'create')) || change.method.includes(helper._mapPropToMethod(filter, 'add')) || change.method.includes(helper._mapPropToMethod(filter, 'remove')) || change.method.includes(helper._mapPropToMethod(filter, 'edit'))) {
        new_changes.push(change);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return new_changes;
}

function _post(_x4, _x5, _x6) {
  return _post2.apply(this, arguments);
}

function _post2() {
  _post2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(token, context, change) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!change.method.includes('edit')) {
              _context3.next = 6;
              break;
            }

            _context3.next = 3;
            return context.getters.api.provider[change.method](token, change.payl.id, change.payl);

          case 3:
            return _context3.abrupt("return", _context3.sent);

          case 6:
            if (!change.method.includes('create')) {
              _context3.next = 12;
              break;
            }

            _context3.next = 9;
            return context.getters.api.provider[change.method](token, change.payl);

          case 9:
            return _context3.abrupt("return", _context3.sent);

          case 12:
            if (!change.method.includes('add')) {
              _context3.next = 19;
              break;
            }

            change.payl.object_id = context.getters.getEditedProvider.id;
            _context3.next = 16;
            return context.getters.api.provider[change.method](token, change.payl);

          case 16:
            return _context3.abrupt("return", _context3.sent);

          case 19:
            if (!change.method.includes('remove')) {
              _context3.next = 23;
              break;
            }

            _context3.next = 22;
            return context.getters.api.provider[change.method](token, change.payl.id, change.payl);

          case 22:
            return _context3.abrupt("return", _context3.sent);

          case 23:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _post2.apply(this, arguments);
}

function _post_changes(_x7, _x8, _x9) {
  return _post_changes2.apply(this, arguments);
}

function _post_changes2() {
  _post_changes2 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4(token, context, changes) {
    var errorEvent, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, change;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            errorEvent = false;
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context4.prev = 4;
            _iterator2 = changes[Symbol.iterator]();

          case 6:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              _context4.next = 13;
              break;
            }

            change = _step2.value;
            _context4.next = 10;
            return _post(token, context, change).then(function (res) {
              change.response = res.data;
            })["catch"](function (err) {
              errorEvent = true;
              errorHandler(err, context);
            });

          case 10:
            _iteratorNormalCompletion2 = true;
            _context4.next = 6;
            break;

          case 13:
            _context4.next = 19;
            break;

          case 15:
            _context4.prev = 15;
            _context4.t0 = _context4["catch"](4);
            _didIteratorError2 = true;
            _iteratorError2 = _context4.t0;

          case 19:
            _context4.prev = 19;
            _context4.prev = 20;

            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }

          case 22:
            _context4.prev = 22;

            if (!_didIteratorError2) {
              _context4.next = 25;
              break;
            }

            throw _iteratorError2;

          case 25:
            return _context4.finish(22);

          case 26:
            return _context4.finish(19);

          case 27:
            return _context4.abrupt("return", {
              errorEvent: errorEvent,
              changes: changes
            });

          case 28:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[4, 15, 19, 27], [20,, 22, 26]]);
  }));
  return _post_changes2.apply(this, arguments);
}

var _default = provider;
exports["default"] = _default;


// WEBPACK FOOTER //
// ../capital-finder-vuex/lib/modules/provider.js